// extracted by mini-css-extract-plugin
export default {"root":"ChatForm_root__-b5pm","textareaButtonBlock":"ChatForm_textareaButtonBlock__eRYOh","textarea":"ChatForm_textarea__P+Sja","button":"ChatForm_button__hLeRf"};